// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1RbBl","title":"Info_title__1dKoB","selects":"Info_selects__2XvVv","requiredAsterisk":"Info_requiredAsterisk__YjS-g"};